module.exports = __webpack_public_path__ + "static/img/233.8a250c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/233.jpg
// module id = 85QD
// module chunks = 0